import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from "react";
import { UserCheck01, UserPlus01, } from "@hl/base-components/lib/assets/icons/HDS";
import { ActionIcon, Box, Group } from "@mantine/core";
import { useAuth } from "../../../auth";
import { User } from "../../../auth/User";
export const FollowerTile = (props) => {
    const { displayName, avatarUrl, walletAddress, isFollowing, onFollowClick, onClick, } = props;
    const { authenticated, walletAddress: myWalletAddress } = useAuth();
    const isMyProfile = walletAddress.toLowerCase() === (myWalletAddress === null || myWalletAddress === void 0 ? void 0 : myWalletAddress.toLowerCase());
    const followButton = useMemo(() => {
        if (!walletAddress)
            return null;
        if (authenticated !== true)
            return null;
        if (isMyProfile)
            return null;
        return (_jsx(ActionIcon, { size: 20, title: isFollowing ? "Following" : "Follow", onClick: onFollowClick, color: "textButton", opacity: isFollowing ? 1 : 0.25, children: isFollowing ? _jsx(UserCheck01, {}) : _jsx(UserPlus01, {}) }));
    }, [authenticated, isFollowing, walletAddress, isMyProfile, onFollowClick]);
    return (_jsxs(Group, { position: "apart", onClick: onClick, mih: 48, miw: "100%", children: [_jsx(User, { avatarSize: 24, walletAddress: walletAddress, avatarUrl: avatarUrl, displayName: displayName, shortenAddress: false, verified: props.verified }), _jsx(Box, { px: 12, children: followButton })] }));
};
